import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Loading from '../components/Loading';
import useAuth from './useAuth';

// only allows access to users that are not authenticated
function UnprotectedRoute() {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return <Loading />;
  }

  return isAuthenticated ? <Navigate to="/" /> : <Outlet />;
}

export default UnprotectedRoute;
